import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// @ts-ignore
import Logo from '../../assets/logo.png';

const LoadingOverlay = () => {
  return (
    <Box width="100vw" height="100vh" bgcolor="black" color="white">
      <Box pt="20%" textAlign="center">
        <img src={Logo} alt="logo" />
        <Typography>
          cargando...
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingOverlay;
